import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { _get } from "../Api";
import { FormattedMessage } from "react-intl";
import GetCurrency from "../helper/GetCurrency";
import { useParams } from "react-router-dom";
import cloudStore from "../store/CloudStore";
import withIntl from "../utils/withIntl";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {},
  column: {
    flexBasis: "20%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  hide: {
    [theme.breakpoints.down("sm")]: {
      visibility: "hidden",
    },
  },
  div: {
    borderLeft: "1px solid",
    paddingLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },
}));

const processData = (data, callback) => {
  let result = data.map((row) => {
    let orders = [];
    row.ordergroup.o_m_articles.forEach((omarticle, i) => {
      orders.push({
        name: omarticle.name,
        cost: omarticle.price,
        totalCost: omarticle.total_cost,
        amount: omarticle.amount,
        modifiers: [],
      });
      omarticle.o_m_modifiergroups.forEach((ommodifiergroup) => {
        ommodifiergroup.o_m_modifierarticles.forEach((ommodifierarticle) => {
          orders[i].modifiers.push({
            name: ommodifierarticle.name,
            cost: ommodifierarticle.price,
            amount: ommodifierarticle.amount,
          });
        });
      });
    });

    if (row.receipt_status_id === 2) {
      row.status = "Afgerond";
    } else if (row.receipt_status_id === 1) {
      row.status = "In behandeling";
    } else if (row.receipt_status_id === 3) {
      row.status = "Geannuleerd";
    }

    let date = new Date(row.created_at);
    return {
      created: date.toLocaleString(),
      status: row.status,
      cost: row.total_cost / 100,
      ordersCount: row.ordergroup.o_m_articles.reduce((a, b) => a + (b["amount"] || 0), 0),
      orders: orders,
      tableId: row.table_id,
    };
  });
  callback(result);
};

const fetchData = (id, page, perPage, callback) => {
  _get("/nova/pillar_merchant/" + id + "/pillar_receipt?number_per_page=" + perPage + "&page=" + page)
    .then((res) => {
      processData(res.data, callback);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      callback(null, e);
    });
};

function PillarOrders() {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [orders, setOrders] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [perPage, setPerPage] = React.useState(localStorage.getItem("ordersPerPage") || 10);
  const [expanded, setExpanded] = React.useState([]);
  const [pillarMerchantId, setPillarMerchantId] = React.useState(Number.parseInt(useParams().pillarMerchantId));
  const paramPillarMerchantId = Number.parseInt(useParams().pillarMerchantId);

  if (paramPillarMerchantId !== pillarMerchantId || loading) {
    fetchData(pillarMerchantId, page, perPage, (res, e) => {
      if (e) {
        localStorage.setItem("ordersPerPage", 10);
        setPerPage(10);
      } else {
        setLoading(false);
        setOrders(res);
        setPillarMerchantId(paramPillarMerchantId);
      }
    });
  }

  const handleExpansion = (id) => {
    let arr = expanded;
    if (expanded.includes(id)) {
      let index = expanded.indexOf(id);
      arr.splice(index, 1);
      setExpanded([...arr]);
    } else {
      arr.push(id);
      setExpanded([...arr]);
    }
  };

  const fetchNextPage = () => {
    setPage(page + 1);
    setLoading(true);
  };

  const fetchPreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
      setLoading(true);
    }
  };

  const handleExpandAll = () => {
    let arr = [];
    for (let i = 0; i < orders.length; i++) {
      arr.push(i);
    }
    setExpanded([...arr]);
  };

  const handleCollapseAll = () => {
    setExpanded([]);
  };

  const handleItemsPerPage = (event) => {
    setPage(0);
    setPerPage(event.target.value);
    localStorage.setItem("ordersPerPage", event.target.value);
    setLoading(true);
  };

  if (loading || paramPillarMerchantId !== pillarMerchantId) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4">Kiosk Orders - {cloudStore.merchant.name}</Typography>
        <div style={{ margin: "15px" }}>
          <Button onClick={handleExpandAll} style={{ marginRight: "5px" }} variant="outlined">
            <FormattedMessage id={"expand_all"} />
          </Button>
          <Button onClick={handleCollapseAll} variant="outlined">
            <FormattedMessage id={"collapse_all"} />
          </Button>
        </div>
      </div>
      <Divider style={{ marginBottom: "10px" }} />
      <div>
        {orders.map((order, i) => {
          return (
            <div style={{ marginBottom: "10px" }} key={order.id}>
              <Accordion
                expanded={expanded.includes(i)}
                defaultExpanded={false}
                variant="outlined"
                onChange={() => handleExpansion(i)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1c-content" id="panel1c-header">
                  <Grid container direction="row" spacing={2}>
                    <Grid item lg={2} md={0} sm={0} xs={0} className={classes.hide}>
                      <Typography className={classes.heading}>{order.created}</Typography>
                    </Grid>
                    <Grid item lg={1} md={6} sm={6} xs={6}>
                      <Typography
                        className={classes.secondaryHeading}
                        style={{
                          color: order.status === "Afgerond" ? "grey" : "red",
                        }}
                      >
                        {order.status}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} xs={0} className={classes.hide}>
                      <Typography className={clsx(classes.secondaryHeading, classes.hide)}>
                        {order.ordersCount} item(s)
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography className={classes.secondaryHeading}>
                        {GetCurrency()} {order.cost.toFixed(2)}
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container xs={12}>
                    <Grid item container lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: 20 }} direction="column">
                      <div>
                        <Typography variant="caption">Bestelling Kiosk</Typography>
                        <br />
                      </div>

                      <br />
                      <div />
                    </Grid>
                    <Grid item container lg={6} md={6} sm={12} xs={12}>
                      <div
                        className={classes.div}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "inherit",
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Typography style={{ flexBasis: "35%", fontWeight: "bold" }} variant="caption">
                            Naam
                          </Typography>
                          <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                            Prijs per stuk
                          </Typography>
                          <Typography style={{ flexBasis: "15%", fontWeight: "bold" }} variant="caption">
                            Hoeveelheid
                          </Typography>
                          <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                            Totaal
                          </Typography>
                        </div>
                        <Divider />
                        {order.orders.map((item) => {
                          return (
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Typography style={{ flexBasis: "35%" }} variant="caption">
                                  {item.name}
                                </Typography>
                                <Typography style={{ flexBasis: "25%" }} variant="caption">
                                  {GetCurrency()} {(item.cost / 100).toFixed(2)}
                                </Typography>
                                <Typography style={{ flexBasis: "15%" }} variant="caption">
                                  {item.amount}
                                  {item.amount === "" ? "" : "x"}
                                </Typography>
                                <Typography style={{ flexBasis: "25%" }} variant="caption">
                                  {GetCurrency()}{" "}
                                  {item.amount === ""
                                    ? (item.cost / 100).toFixed(2)
                                    : (item.totalCost / 100).toFixed(2)}
                                </Typography>
                              </div>
                              <div>
                                {item.modifiers
                                  ? item.modifiers.map((modifier) => {
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              flexBasis: "35%",
                                              fontSize: "80%",
                                              color: "grey",
                                            }}
                                            variant="caption"
                                          >
                                            {" "}
                                            > {modifier.name}
                                          </Typography>
                                          <Typography
                                            style={{
                                              flexBasis: "25%",
                                              fontSize: "80%",
                                              color: "grey",
                                            }}
                                            variant="caption"
                                          >
                                            {modifier.cost === 0
                                              ? ""
                                              : "+" + GetCurrency() + " " + (modifier.cost / 100).toFixed(2)}
                                          </Typography>
                                        </div>
                                      );
                                    })
                                  : null}
                              </div>
                            </div>
                          );
                        })}
                        <Divider variant="light" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography style={{ flexBasis: "75%" }}>Totaal</Typography>
                          <Typography style={{ flexBasis: "25%" }}>
                            {GetCurrency()} {order.cost.toFixed(2)}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
      </div>

      <div>
        <Paper variant="outlined" style={{ height: "4em" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justify: "space-around",
            }}
          >
            <div
              style={{
                margin: "0 auto",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Typography style={{ marginTop: "15px", marginRight: "40px" }}>Page: {page + 1}</Typography>
              <Typography style={{ marginTop: "15px", marginRight: "10px" }}>Items per page: </Typography>
              <Select
                onChange={handleItemsPerPage}
                value={perPage}
                variant="outlined"
                style={{
                  height: "2em",
                  marginTop: "12px",
                  marginRight: "10px",
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>

              <IconButton onClick={fetchPreviousPage} style={{ marginTop: "5px" }}>
                <ChevronLeft />
              </IconButton>
              <IconButton onClick={fetchNextPage} style={{ marginTop: "5px" }}>
                <ChevronRight />
              </IconButton>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
}

export default withIntl(PillarOrders);
